import { render, staticRenderFns } from "./ConfigFile.vue?vue&type=template&id=646eb68e"
import script from "./ConfigFile.vue?vue&type=script&lang=js"
export * from "./ConfigFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/8268df4d62037a26/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('646eb68e')) {
      api.createRecord('646eb68e', component.options)
    } else {
      api.reload('646eb68e', component.options)
    }
    module.hot.accept("./ConfigFile.vue?vue&type=template&id=646eb68e", function () {
      api.rerender('646eb68e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/Collector/ConfigFile.vue"
export default component.exports